// Central place for all static site content (no placeholders - real content)

export const SITE = {
  name: "Tathastu Jotishalaya",
  tagline: "Authentic Vedic Poojas & Trusted Astrology Guidance in Thane",
  domain: "https://tathastujotishalaya.com",
  address: "Thane, Maharashtra, India",
  whatsappBase: "https://wa.me/",
};

export const SAURABH = {
  name: "Saurabh Shastri",
  role: "Vedic Pandit & Pooja Specialist",
  phone: "7057415028",
  phoneDisplay: "+91 70574 15028",
  whatsapp: "917057415028",
  image: "/images/saurabh-shastri.avif",
  intro:
    "Pandit Saurabh Shastri is a learned Vedic priest based in Thane, devoted to performing authentic, Shastra-sanctioned poojas and sanskars with complete devotion and precision. With years of experience guiding families through life's most sacred rituals, Saurabh Shastri ensures every ceremony is conducted exactly as prescribed in the scriptures - bringing peace, prosperity and divine blessings into your home.",
  about:
    "Trained in traditional Vedic rituals and mantra recitation since childhood, Saurabh Shastri has dedicated his life to preserving and performing authentic Hindu ceremonies. He is known across Thane and Mumbai for his calm, clear guidance, punctuality, and the genuine devotion he brings to every pooja - whether it is a small home ceremony or a large community yagna. He personally guides each family through the significance of every ritual step so they understand and feel connected to the sanskar being performed.",
  services: [
    {
      title: "Satyanarayan Mahapuja",
      slug: "satyanarayan-mahapuja",
      image: "/images/satyanarayana.jpg",
      desc: "A sacred puja dedicated to Lord Vishnu (Satyanarayan), performed to bring prosperity, fulfillment of wishes, and removal of obstacles. Ideal for housewarmings, anniversaries, promotions and thanksgiving occasions.",
    },
    {
      title: "Vastu Shanti Pujan",
      slug: "vastu-shanti-pujan",
      image: "/images/satyanarayana.jpg",
      desc: "Performed before or after moving into a new home or office to neutralize Vastu doshas (architectural defects) and invite positive energy, peace and harmony into the space.",
    },
    {
      title: "Ganesh Poojan",
      slug: "ganesh-poojan",
      image: "/images/satyanarayana.jpg",
      desc: "Worship of Lord Ganesha to remove obstacles and ensure an auspicious beginning to any new venture, ceremony, or festival - including Ganesh Chaturthi installations and visarjan rituals.",
    },
    {
      title: "Gruhpravesh Vidhi",
      slug: "gruhpravesh-vidhi",
      image: "/images/satyanarayana.jpg",
      desc: "The traditional housewarming ceremony performed when entering a new home, invoking blessings for the household's health, wealth and happiness as per Vedic tradition.",
    },
    {
      title: "Namkaran Sanskar",
      slug: "namkaran-sanskar",
      image: "/images/satyanarayana.jpg",
      desc: "The sacred naming ceremony for a newborn, performed according to the child's Nakshatra and horoscope, marking one of the sixteen essential Hindu sanskars.",
    },
    {
      title: "Vivah Sanskar",
      slug: "vivah-sanskar",
      image: "/images/satyanarayana.jpg",
      desc: "Complete Vedic wedding rituals conducted with proper mantras and customs - from Ganesh Pooja and Mangalashtak to Saptapadi and Kanyadaan - ensuring a blessed and authentic marriage ceremony.",
    },
    {
      title: "Navchandi Yag",
      slug: "navchandi-yag",
      image: "/images/satyanarayana.jpg",
      desc: "A powerful havan dedicated to Goddess Durga, performed for protection from negative energies, removal of major obstacles, and invoking the Goddess's blessings for strength and victory.",
    },
    {
      title: "Navgraha Shanti",
      slug: "navgraha-shanti",
      image: "/images/satyanarayana.jpg",
      desc: "A peace ritual for the nine planetary deities (Navagrahas), performed to pacify malefic planetary influences identified in one's horoscope and restore balance and well-being.",
    },
  ],
  otherServices: [
    "Satyanarayan Katha & Puja",
    "Griha Shanti Pooja",
    "Rudra Abhishek",
    "Mundan Sanskar (Tonsure Ceremony)",
    "Annaprashan Sanskar",
    "Engagement (Sagai) Rituals",
    "Griha Pravesh Muhurat Selection",
    "Shraddha & Pitru Paksha Rituals",
    "Satyanarayan Katha on Festivals",
    "Lakshmi Pooja (Diwali)",
    "Saraswati Pooja",
    "Office / Shop Opening Pooja",
    "Vehicle Pooja",
    "Custom Havan & Yagna as per requirement",
  ],
};

export const GAURI = {
  name: "Gauri Shastri",
  role: "Astrologer & Palmist",
  phone: "8087476693",
  phoneDisplay: "+91 80874 76693",
  whatsapp: "918087476693",
  image: "/images/gauri-shastri.avif",
  intro:
    "Gauri Shastri is an experienced Astrologer and Palmist based in Thane, offering accurate horoscope readings, palm analysis and effective remedies to clients across Thane, Mumbai and around the world via online consultations.",
  about:
    "With deep study and years of practical experience in Vedic Astrology (Jyotish Shastra) and Hast Rekha Shastra (Palmistry), Gauri Shastri has helped countless individuals and families find clarity and direction in matters of marriage, career, health, business and personal growth. Her approach combines traditional astrological wisdom with practical, easy-to-follow remedies - making ancient knowledge accessible and genuinely useful in modern life. Consultations are available in person in Thane or online for clients anywhere in the world.",
  services: [
    {
      title: "Horoscope (Kundali) Preparation",
      slug: "horoscope-preparation",
      image: "/images/satyanarayana.jpg",
      desc: "Detailed and accurate birth chart (Kundali) preparation based on exact birth date, time and place - forming the foundation for all astrological guidance and predictions.",
    },
    {
      title: "Accurate Guidance & Remedies as per Horoscope",
      slug: "guidance-remedies-horoscope",
      image: "/images/satyanarayana.jpg",
      desc: "In-depth analysis of your horoscope to provide clear, accurate guidance along with practical and effective remedies tailored to your specific planetary positions.",
    },
    {
      title: "Remedies for Planetary Defects (Dosha Nivaran)",
      slug: "planetary-defects-remedies",
      image: "/images/satyanarayana.jpg",
      desc: "Identification of doshas like Mangal Dosha, Kaal Sarp Dosha, Pitru Dosha and others, along with simple, effective remedies to minimize their negative effects.",
    },
    {
      title: "Marriage Matching & Guidance",
      slug: "marriage-matching",
      image: "/images/satyanarayana.jpg",
      desc: "Kundali Milan (horoscope matching) for prospective marriages, along with guidance on resolving delays or obstacles in marriage through astrological remedies.",
    },
    {
      title: "Progeny (Santati) Guidance",
      slug: "progeny-guidance",
      image: "/images/satyanarayana.jpg",
      desc: "Astrological analysis and remedies for couples facing delays or concerns related to having children, based on careful study of relevant planetary placements.",
    },
    {
      title: "Business & Career Guidance",
      slug: "business-career-guidance",
      image: "/images/satyanarayana.jpg",
      desc: "Astrological insights into the right career path, business decisions, partnerships and timing, along with remedies to overcome professional obstacles.",
    },
    {
      title: "Remedies for Obstacles (Vighna Nivaran)",
      slug: "obstacle-remedies",
      image: "/images/satyanarayana.jpg",
      desc: "Practical astrological remedies to identify and remove recurring obstacles in life - whether related to health, finances, relationships or personal growth.",
    },
    {
      title: "Palmistry (Hast Rekha Shastra) Reading",
      slug: "palmistry-reading",
      image: "/images/satyanarayana.jpg",
      desc: "Detailed analysis of palm lines, mounts and signs to provide accurate insights into your personality, life path, health, wealth and relationships.",
    },
    {
      title: "Complete Arrangement of Puja Material",
      slug: "puja-material-arrangement",
      image: "/images/satyanarayana.jpg",
      desc: "Convenient, complete arrangement of all puja samagri (ritual materials) required for any recommended remedy or ceremony - so you don't have to worry about sourcing items yourself.",
    },
  ],
};

export const SERVICE_AREAS = [
  "Thane West",
  "Thane East",
  "Ghodbunder Road",
  "Kolshet Road",
  "Majiwada",
  "Vartak Nagar",
  "Naupada",
  "Vasant Vihar",
  "Hiranandani Estate",
  "Pokhran Road",
  "Manpada",
  "Mumbai",
  "Navi Mumbai",
  "Mulund",
  "Bhandup",
  "Dombivli",
  "Kalyan",
];

// `icon` is a key resolved to a react-icon component in StatsCounter.js
export const STATS = [
  { icon: "flame", value: 500, suffix: "+", label: "Poojas Performed" },
  { icon: "om", value: 10, suffix: "+", label: "Years of Experience" },
  { icon: "crystal", value: 1000, suffix: "+", label: "Astro Consultations" },
  { icon: "star", value: 4.9, suffix: "", label: "Devotee Rating" },
];

export const FAQS = [
  {
    q: "Which areas do you serve for pooja services?",
    a: "Pandit Saurabh Shastri performs poojas in person across Thane West, Thane East, Ghodbunder Road, Majiwada, Mumbai, Navi Mumbai, Mulund, Dombivli, Kalyan and nearby areas. For devotees elsewhere, we can guide you on arrangements or connect you with trusted local pandits.",
  },
  {
    q: "Can astrology consultations be done online?",
    a: "Yes. Gauri Shastri offers detailed horoscope readings and palmistry consultations online via phone or video call, so you can consult from anywhere in the world. For palmistry, clear photos of both palms are sufficient.",
  },
  {
    q: "Do you arrange the puja samagri (ritual materials)?",
    a: "Absolutely. We can either guide you on the complete list of required items or arrange everything for you hassle-free, so you can focus on the devotion while we handle the logistics.",
  },
  {
    q: "How do we decide the right muhurat (auspicious timing)?",
    a: "Once you share the occasion and the birth details of the family members involved, we calculate an auspicious date and time as per Vedic Panchang and suggest the most suitable muhurat for your ceremony.",
  },
  {
    q: "How are payments and bookings handled?",
    a: "Bookings are confirmed over a phone call or WhatsApp. We will share all the details - timing, samagri, and any contribution - clearly in advance so there are no surprises. Reach out on WhatsApp for the quickest response.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Mrs. Sunita Patil",
    location: "Thane West",
    text: "Saurabh Shastri performed our Gruhpravesh Vidhi with so much devotion and clarity. He explained every step so we truly understood the significance. Highly recommend for anyone looking for an authentic pandit in Thane.",
  },
  {
    name: "Rajesh Iyer",
    location: "Hiranandani Estate, Thane",
    text: "We consulted Gauri Shastri for our daughter's marriage matching. Her horoscope reading was extremely detailed and the remedies she suggested genuinely helped resolve the delays we were facing. Very accurate and caring approach.",
  },
  {
    name: "Anita & Vikram Deshmukh",
    location: "Mulund, Mumbai",
    text: "The Satyanarayan Mahapuja conducted by Saurabh Shastri for our housewarming was beautifully done. He arrived on time, brought clarity to every ritual, and made the entire family feel blessed.",
  },
  {
    name: "Prachi Joshi",
    location: "Kolshet Road, Thane",
    text: "Gauri Shastri's palmistry reading was incredibly insightful. She picked up on details about my career path that helped me make an important decision with confidence. Her remedies are simple and effective.",
  },
];
